export const Lesson = {
  Option: {
    SUCCESS: "👍🏻 Успішно проведений",
    CANCELED: "✖️ Неявка студента",
    MOVED: "Урок перенесений",
  },
};
